import {
  AuthTypeRoutes,
} from '@equifinance/shared';
import {
  Outlet, useOutletContext,
} from 'react-router-dom';
import { RoutingContextType } from '.';
import HomeUnderwriter from '../pages/HomeUnderwriter';
import Home from '../pages/Home';
import { CombinedProvider, UnderwriterCombinedProvider } from '../contexts/providers/CombineProvider';

function AuthComponent() {
  return (
    <CombinedProvider>
      <Home />
    </CombinedProvider>
  );
}

function MsalComponent() {
  return (
    <UnderwriterCombinedProvider>
      <HomeUnderwriter />
    </UnderwriterCombinedProvider>
  );
}

export function HomepageRoutes() {
  const outletValue: RoutingContextType = useOutletContext();

  return (
    <AuthTypeRoutes
      DefaultComponent={<Outlet context={outletValue} />}
      AuthComponent={<AuthComponent />}
      MsalComponent={<MsalComponent />}
    />
  );
}
